<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showFacility") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <div class="badges_wrapper justify-content-end">
        <v-chip :color="data.is_active ? 'green' : 'red'" text-color="white">
          {{ data.is_active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>

      <form>
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facilityNameAr')"
            v-model.trim="data.name_ar"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facilityNameEn')"
            v-model.trim="data.name_en"
            disabled
          />

          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.radiusKm')"
            v-model.trim="data.radius"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.latitude')"
            v-model.trim="data.lat"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.longitude')"
            v-model.trim="data.long"
            disabled
          /> -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.createdAt')"
            v-model.trim="data.created_at"
            disabled
          />
        </div>
      </form>

      <div class="mt-4">
        <ChangableMapComponent
          :lat="parseFloat(data.lat || 24.7136)"
          :lng="parseFloat(data.long || 46.6753)"
          selection-mode="points"
          :points="data.shape"
          :interactive="false"
          :auto-fit-bounds="true"
          :zoom="6"
          @update:lat="() => {}"
          @update:lng="() => {}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "ShowFacility",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    ChangableMapComponent,
  },

  data() {
    return {
      data: {
        name_ar: null,
        name_en: null,
        address: null,
        lat: null,
        long: null,
        shape: [],
        radius: null,
        is_active: false,
        created_at: null,
      },
    };
  },

  methods: {
    normalizeShape(shape) {
      if (!Array.isArray(shape)) return [];

      return shape
        .map((point) => {
          const lat = Number(point?.lat);
          const long = Number(point?.long ?? point?.lng);

          if (!Number.isFinite(lat) || !Number.isFinite(long)) return null;

          return { lat, long };
        })
        .filter(Boolean);
    },

    async getDataToShow() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `facilities/${this.id}`,
        });

        const facility = res.data.data.data;
        this.data.name_ar = facility.name_ar || facility.name;
        this.data.name_en = facility.name_en || facility.name;
        this.data.address = facility.address;
        this.data.lat = facility.lat;
        this.data.long = facility.long;
        this.data.shape = this.normalizeShape(facility.shape);
        if (this.data.shape.length > 0) {
          this.data.lat = this.data.shape[0].lat;
          this.data.long = this.data.shape[0].long;
        }
        this.data.radius = facility.radius;
        this.data.is_active = !!facility.is_active;
        this.data.created_at = facility.created_at;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
  },

  async created() {
    await this.getDataToShow();
  },
};
</script>
